<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import MfEmpty from "@/components/core/MfEmpty.vue";

// Faqat shu 4 ta maydon tahrirlanadi va PUT da yuboriladi.
// id / boardId / votingEndDate UI da ko'rsatilmaydi.
const EDITABLE_FIELDS = [
  {
    prop: "otpMaxTryCount",
    label: "OTP urinishlar soni",
    hint: "Bir kod uchun ruxsat etilgan maksimal urinish",
  },
  {
    prop: "smsDailyLimit",
    label: "Kunlik SMS limiti",
    hint: "Bitta foydalanuvchiga kuniga yuboriladigan SMS soni",
  },
  {
    prop: "minVoteCountForWin",
    label: "G'alaba uchun minimal ovoz",
    hint: "Tashabbus g'olib bo'lishi uchun kerakli eng kam ovoz",
  },
  {
    prop: "pendingTimeMinute",
    label: "Kutish vaqti (daqiqa)",
    hint: "Qayta kod so'rashdan oldingi kutish vaqti",
  },
];

const emptyForm = () => ({
  otpMaxTryCount: null,
  smsDailyLimit: null,
  minVoteCountForWin: null,
  pendingTimeMinute: null,
});

// G'oliblarni e'lon qilish oqimi — ketma-ketlik qat'iy: har bosqich oldingisi
// muvaffaqiyatli tugagandan keyingina ishga tushadi.
const WINNER_STEPS = [
  {
    key: "vote-count",
    title: "Ovozlarni hisoblash",
    description:
        "Mavsum bo'yicha berilgan barcha ovozlar yakuniy hisob-kitob qilinadi.",
    endpoint: "api/v2/vote/admin/winner/vote-count",
    confirmTitle: "Ovozlarni hisoblash",
    confirmText:
        "Mavsumdagi ovozlar qayta hisoblanadi. Davom etasizmi?",
    successText: "Ovozlar hisoblandi",
  },
  {
    key: "make-winner",
    title: "G'oliblarni e'lon qilish",
    description:
        "Hisoblangan ovozlar asosida g'olib tashabbuslar belgilanadi.",
    endpoint: "api/v2/vote/admin/winner/make-winner",
    confirmTitle: "G'oliblarni e'lon qilish",
    confirmText:
        "G'olib tashabbuslar belgilanadi. Bu amalni ortga qaytarib bo'lmaydi. Davom etasizmi?",
    successText: "G'oliblar e'lon qilindi",
  },
  {
    key: "winner-sms",
    title: "G'oliblarga SMS jo'natish",
    description:
        "G'olib tashabbus mualliflariga xabarnoma SMS yuboriladi.",
    endpoint: "api/v2/vote/admin/winner/winner-sms",
    confirmTitle: "SMS jo'natish",
    confirmText:
        "G'oliblarga SMS jo'natiladi. Yuborilgan SMS ni bekor qilib bo'lmaydi. Davom etasizmi?",
    successText: "SMS jo'natildi",
  },
];

export default {
  name: "BoardVoteSettings",
  components: {MfEmpty},
  data() {
    return {
      activeTab: "properties",
      loading: false,
      saving: false,
      hasError: false,
      errorMessage: "",
      propertyId: null,
      form: emptyForm(),
      editableFields: EDITABLE_FIELDS,
      rules: EDITABLE_FIELDS.reduce((acc, field) => {
        acc[field.prop] = [
          {required: true, message: "Maydonni to'ldiring", trigger: "blur"},
        ];
        return acc;
      }, {}),

      // --- Bloklangan tumanlar tabi ---
      catalogLoaded: false,
      regionsLoading: false,
      districtsLoading: false,
      regions: [],
      // districtId -> {title, regionTitle} — bloklangan ro'yxatda faqat districtId
      // kelgani uchun nomlarni shu map dan olamiz.
      districtMap: {},
      districtsByRegion: {},
      selectedRegion: null,
      selectedDistrictIds: [],
      blockedList: [],
      blockedLoading: false,
      addingBlocked: false,
      deletingBlockedId: null,
      blockedDialogVisible: false,

      // --- G'oliblarni e'lon qilish tabi ---
      winnerSteps: WINNER_STEPS,
      // Har bosqich holati: wait | process | finish | error. Bu holat faqat
      // brauzerda saqlanadi — sahifa yangilanganda bosqichlar boshidan ko'rinadi.
      winnerStates: WINNER_STEPS.map(() => ({status: "wait", message: ""})),
      winnerRunningIndex: null,
      winnerRunningAll: false,
    };
  },
  computed: {
    boardId() {
      return this.$route.params.id;
    },
    // Sozlama topilmaganda forma o'rniga bo'sh holat ko'rsatiladi.
    hasProperties() {
      return this.propertyId !== null;
    },
    blockedDistrictIds() {
      return this.blockedList.map((item) => item.districtId);
    },
    // Tanlangan viloyatning allaqachon bloklanmagan tumanlari.
    availableDistricts() {
      const list = this.districtsByRegion[this.selectedRegion] || [];
      return list.filter((item) => !this.blockedDistrictIds.includes(item.id));
    },
    blockedRows() {
      return this.blockedList.map((item) => ({
        ...item,
        districtTitle: item?.title,
        RegionTitle: item?.region,
      }));
    },
    // el-steps uchun: birinchi tugallanmagan bosqich indeksi.
    winnerActiveStep() {
      const index = this.winnerStates.findIndex(
          (state) => state.status !== "finish"
      );
      return index === -1 ? this.winnerSteps.length : index;
    },
    winnerAllDone() {
      return this.winnerStates.every((state) => state.status === "finish");
    },
    winnerBusy() {
      return this.winnerRunningAll || this.winnerRunningIndex !== null;
    },
    winnerStarted() {
      return this.winnerStates.some((state) => state.status !== "wait");
    },
  },
  methods: {
    fetchProperties() {
      this.loading = true;
      this.hasError = false;
      this.errorMessage = "";
      this.$http
          .get("api/v2/vote/admin/board-properties", {
            params: {boardId: this.boardId},
          })
          .then(({data}) => {
            // Javob massiv — mavsumga tegishli birinchi yozuvni olamiz.
            const item = Array.isArray(data) ? data[0] : data;
            if (!item) {
              this.propertyId = null;
              this.form = emptyForm();
              return;
            }
            this.propertyId = item.id;
            this.form = {
              otpMaxTryCount: item.otpMaxTryCount,
              smsDailyLimit: item.smsDailyLimit,
              minVoteCountForWin: item.minVoteCountForWin,
              pendingTimeMinute: item.pendingTimeMinute,
            };
          })
          .catch(({response}) => {
            this.hasError = true;
            this.errorMessage =
                response?.data?.message ||
                "Ovoz berish sozlamalarini yuklashda xatolik yuz berdi.";
            ElNotification.error({title: "Xatolik", message: this.errorMessage});
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        this.$http
            .put(`api/v2/vote/admin/board-properties/${this.propertyId}`, {
              otpMaxTryCount: Number(this.form.otpMaxTryCount),
              smsDailyLimit: Number(this.form.smsDailyLimit),
              minVoteCountForWin: Number(this.form.minVoteCountForWin),
              pendingTimeMinute: Number(this.form.pendingTimeMinute),
            })
            .then(() => {
              ElMessage({type: "success", message: "Sozlamalar saqlandi"});
              this.fetchProperties();
            })
            .catch(({response}) => {
              ElNotification.error({
                title: "Xatolik",
                message:
                    response?.data?.message || "Saqlashda xatolik yuz berdi.",
              });
            })
            .finally(() => {
              this.saving = false;
            });
      });
    },

    // --- Bloklangan tumanlar ---
    // Tab birinchi ochilganda faqat 2 ta so'rov: viloyatlar + bloklanganlar ro'yxati.
    // Tumanlar viloyat tanlangandagina yuklanadi.
    onTabChange(name) {
      if (name !== "blocked-districts" || this.catalogLoaded) return;
      this.catalogLoaded = true;
      this.fetchRegions();
      this.fetchBlocked();
    },
    fetchRegions() {
      this.regionsLoading = true;
      this.$http
          .get("api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions || [];
          })
          .catch(({response}) => {
            ElNotification.error({
              title: "Xatolik",
              message:
                  response?.data?.message ||
                  "Viloyatlar ro'yxatini yuklashda xatolik yuz berdi.",
            });
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    // Har viloyat uchun bir martadan yuklanadi, keyin keshdan olinadi.
    fetchDistricts(regionId) {
      if (this.districtsByRegion[regionId]) return;
      this.districtsLoading = true;
      const region = this.regions.find((item) => item.id === regionId);
      this.$http
          .get("api/v1/districts", {params: {region_id: regionId}})
          .then(({data}) => {
            const districts = data.districts || [];
            this.districtsByRegion = {...this.districtsByRegion, [regionId]: districts};
            // Jadvaldagi nomlar shu keshdan chiqadi — yuklangan sari to'ldirib boramiz.
            const map = {...this.districtMap};
            districts.forEach((district) => {
              map[district.id] = {
                title: district.title,
                regionTitle: region?.title || "-",
              };
            });
            this.districtMap = map;
          })
          .catch(({response}) => {
            ElNotification.error({
              title: "Xatolik",
              message:
                  response?.data?.message ||
                  "Tumanlar ro'yxatini yuklashda xatolik yuz berdi.",
            });
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    fetchBlocked() {
      this.blockedLoading = true;
      this.$http
          .get("api/v1/blocked-districts", {
            params: {board_id: this.boardId},
          })
          .then(({data}) => {
            this.blockedList = Array.isArray(data) ? data : [];
          })
          .catch(({response}) => {
            ElNotification.error({
              title: "Xatolik",
              message:
                  response?.data?.message ||
                  "Bloklangan tumanlarni yuklashda xatolik yuz berdi.",
            });
          })
          .finally(() => {
            this.blockedLoading = false;
          });
    },
    onRegionChange(regionId) {
      this.selectedDistrictIds = [];
      if (regionId) this.fetchDistricts(regionId);
    },
    openBlockedDialog() {
      this.selectedRegion = null;
      this.selectedDistrictIds = [];
      this.blockedDialogVisible = true;
    },
    onAddBlocked() {
      if (!this.selectedDistrictIds.length) return;
      this.addingBlocked = true;
      this.$http
          .post("api/v2/vote/admin/blocked-districts", {
            boardId: Number(this.boardId),
            districtIdList: this.selectedDistrictIds,
          })
          .then(() => {
            ElMessage({type: "success", message: "Tumanlar bloklandi"});
            this.selectedDistrictIds = [];
            this.blockedDialogVisible = false;
            this.fetchBlocked();
          })
          .catch(({response}) => {
            ElNotification.error({
              title: "Xatolik",
              message:
                  response?.data?.message || "Bloklashda xatolik yuz berdi.",
            });
          })
          .finally(() => {
            this.addingBlocked = false;
          });
    },
    onRemoveBlocked(row) {
      ElMessageBox.confirm(
          `"${row.districtTitle}" blokdan chiqariladi. Davom etasizmi?`,
          "Blokdan chiqarish",
          {
            confirmButtonText: "Ha, chiqarilsin",
            cancelButtonText: "Bekor qilish",
            type: "warning",
          }
      )
          .then(() => {
            this.deletingBlockedId = row.id;
            this.$http
                .delete(`api/v2/vote/admin/blocked-districts/${row.id}`)
                .then(() => {
                  ElMessage({type: "success", message: "Tuman blokdan chiqarildi"});
                  this.fetchBlocked();
                })
                .catch(({response}) => {
                  ElNotification.error({
                    title: "Xatolik",
                    message:
                        response?.data?.message ||
                        "Blokdan chiqarishda xatolik yuz berdi.",
                  });
                })
                .finally(() => {
                  this.deletingBlockedId = null;
                });
          })
          .catch(() => {
            ElMessage({type: "info", message: "Amaliyot bekor qilindi"});
          });
    },

    // --- G'oliblarni e'lon qilish ---
    // Bosqich faqat oldingisi "finish" bo'lganda ochiladi; tugagan bosqich
    // qayta bajarilmaydi (avval "Bosqichlarni tozalash" kerak).
    canRunWinnerStep(index) {
      if (this.winnerBusy) return false;
      if (this.winnerStates[index].status === "finish") return false;
      if (index === 0) return true;
      return this.winnerStates[index - 1].status === "finish";
    },
    setWinnerState(index, status, message = "") {
      const states = [...this.winnerStates];
      states[index] = {status, message};
      this.winnerStates = states;
    },
    // Bitta bosqichni bajaradi. Muvaffaqiyat bo'lsa true qaytaradi —
    // ketma-ket rejimda shu qiymat keyingi bosqichga o'tishni hal qiladi.
    async runWinnerStep(index) {
      const step = this.winnerSteps[index];
      this.winnerRunningIndex = index;
      this.setWinnerState(index, "process");
      try {
        const {data} = await this.$http.post(step.endpoint, {}, {
          params: {boardId: Number(this.boardId)},
        });
        const message =
            typeof data === "string" ? data : data?.message || step.successText;
        this.setWinnerState(index, "finish", message);
        return true;
      } catch ({response}) {
        const message =
            response?.data?.message || "Bosqichni bajarishda xatolik yuz berdi.";
        this.setWinnerState(index, "error", message);
        ElNotification.error({title: step.title, message});
        return false;
      } finally {
        this.winnerRunningIndex = null;
      }
    },
    async onRunWinnerStep(index) {
      const step = this.winnerSteps[index];
      try {
        await ElMessageBox.confirm(step.confirmText, step.confirmTitle, {
          confirmButtonText: "Ha, bajarilsin",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        });
      } catch {
        return;
      }
      const success = await this.runWinnerStep(index);
      if (success) {
        ElMessage({type: "success", message: step.successText});
      }
    },
    // Qolgan barcha bosqichlarni ketma-ket bajaradi, birinchi xatoda to'xtaydi.
    async onRunAllWinnerSteps() {
      try {
        await ElMessageBox.confirm(
            "Ovozlar hisoblanadi, g'oliblar e'lon qilinadi va ularga SMS jo'natiladi. " +
            "Bu amallarni ortga qaytarib bo'lmaydi. Davom etasizmi?",
            "Barcha bosqichlarni bajarish",
            {
              confirmButtonText: "Ha, boshlansin",
              cancelButtonText: "Bekor qilish",
              type: "warning",
            }
        );
      } catch {
        return;
      }
      this.winnerRunningAll = true;
      try {
        for (let index = 0; index < this.winnerSteps.length; index += 1) {
          if (this.winnerStates[index].status === "finish") continue;
          const success = await this.runWinnerStep(index);
          if (!success) return;
        }
        ElNotification.success({
          title: "Tayyor",
          message: "Barcha bosqichlar muvaffaqiyatli bajarildi.",
        });
      } finally {
        this.winnerRunningAll = false;
      }
    },
    resetWinnerFlow() {
      this.winnerStates = this.winnerSteps.map(() => ({
        status: "wait",
        message: "",
      }));
    },
  },
  mounted() {
    this.fetchProperties();
  },
};
</script>

<template>
  <div class="vote-settings">
    <div class="header">
      <el-button class="back-btn" @click="$router.push({name: 'BoardsList'})">
        <img height="12" src="@/assets/images/icons/arrow-left.svg" alt=""/>
        <span>Orqaga</span>
      </el-button>
      <h2 class="page-title">Ovoz berish sozlamasi</h2>
    </div>

    <el-tabs v-model="activeTab" class="tabs" @tab-change="onTabChange">
      <el-tab-pane label="Sozlamalar" name="properties">
        <div v-if="hasError" class="state-block">
          <el-result
              icon="error"
              title="Ma'lumotlarni yuklab bo'lmadi"
              :sub-title="errorMessage"
          >
            <template #extra>
              <el-button type="primary" @click="fetchProperties">
                Qayta urinish
              </el-button>
            </template>
          </el-result>
        </div>

        <div v-else-if="loading" class="state-block">
          <el-skeleton :rows="5" animated/>
        </div>

        <div v-else-if="!hasProperties" class="state-block">
          <MfEmpty
              title="Ovoz berish sozlamalari topilmadi"
              description="Bu mavsum uchun sozlama hali yaratilmagan"
          />
        </div>

        <el-form
            v-else
            ref="formRef"
            :model="form"
            :rules="rules"
            label-position="top"
            class="form"
        >
          <el-form-item
              v-for="field in editableFields"
              :key="field.prop"
              :label="field.label"
              :prop="field.prop"
          >
            <el-input-number
                v-model="form[field.prop]"
                :min="0"
                :controls="false"
                class="number-input"
            />
            <p class="field-hint">{{ field.hint }}</p>
          </el-form-item>

          <div class="form-actions">
            <el-button type="primary" :loading="saving" @click="onSubmit">
              Saqlash
            </el-button>
          </div>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Bloklangan tumanlar" name="blocked-districts">
        <div class="blocked-add">
          <el-button type="primary" @click="openBlockedDialog">
            Tuman bloklash
          </el-button>
        </div>

        <div v-if="blockedLoading" class="state-block">
          <el-skeleton :rows="5" animated/>
        </div>

        <div v-else-if="!blockedRows.length" class="state-block">
          <MfEmpty
              title="Bloklangan tumanlar yo'q"
              description="Yuqoridan viloyat va tumanlarni tanlab bloklashingiz mumkin"
          />
        </div>

        <el-table v-else :data="blockedRows" border>
          <el-table-column type="index" width="60" label="#"/>
          <el-table-column prop="RegionTitle" label="Viloyat" min-width="220"/>
          <el-table-column prop="districtTitle" label="Tuman" min-width="220"/>
          <el-table-column label="Amallar" width="140" align="center">
            <template #default="scope">
              <el-tooltip content="Blokdan chiqarish" placement="top">
                <el-button
                    type="danger"
                    class="action-btn"
                    :loading="deletingBlockedId === scope.row.id"
                    @click="onRemoveBlocked(scope.row)"
                >
                  <img height="16" src="@/assets/images/icons/delete.svg" alt="Blokdan chiqarish"/>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="G'oliblarni e'lon qilish" name="winners">
        <div class="winner-flow">
          <el-alert
              type="warning"
              :closable="false"
              show-icon
              title="Bosqichlar qat'iy ketma-ketlikda bajariladi"
              description="Har bir bosqich faqat oldingisi muvaffaqiyatli tugagandan keyin ochiladi. Bosqich holati sahifa yangilanganda saqlanmaydi."
          />

          <el-steps
              :active="winnerActiveStep"
              direction="vertical"
              class="winner-steps"
          >
            <el-step
                v-for="(step, index) in winnerSteps"
                :key="step.key"
                :title="`${index + 1}. ${step.title}`"
                :status="winnerStates[index].status"
            >
              <template #description>
                <div class="winner-step">
                  <p class="winner-step__text">{{ step.description }}</p>

                  <p
                      v-if="winnerStates[index].message"
                      class="winner-step__message"
                      :class="`is-${winnerStates[index].status}`"
                  >
                    {{ winnerStates[index].message }}
                  </p>

                  <div class="winner-step__actions">
                    <el-button
                        v-if="winnerStates[index].status !== 'finish'"
                        size="small"
                        type="primary"
                        plain
                        :disabled="!canRunWinnerStep(index)"
                        :loading="winnerRunningIndex === index"
                        @click="onRunWinnerStep(index)"
                    >
                      {{
                        winnerStates[index].status === "error"
                            ? "Qayta urinish"
                            : "Bajarish"
                      }}
                    </el-button>
                    <el-tag v-else type="success" effect="plain" size="small">
                      Bajarildi
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-step>
          </el-steps>

          <div class="winner-actions">
            <el-button
                type="primary"
                :loading="winnerRunningAll"
                :disabled="winnerAllDone || winnerBusy"
                @click="onRunAllWinnerSteps"
            >
              {{ winnerStarted ? "Qolgan bosqichlarni bajarish" : "Barcha bosqichlarni bajarish" }}
            </el-button>
            <el-button
                v-if="winnerStarted"
                :disabled="winnerBusy"
                @click="resetWinnerFlow"
            >
              Bosqichlarni tozalash
            </el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
        v-model="blockedDialogVisible"
        title="Tuman bloklash"
        width="420px"
        destroy-on-close
    >
      <div class="blocked-dialog-form">
        <el-select
            v-model="selectedRegion"
            placeholder="Viloyatni tanlang"
            filterable
            clearable
            :loading="regionsLoading"
            style="width: 100%"
            @change="onRegionChange"
        >
          <el-option
              v-for="region in regions"
              :key="region.id"
              :label="region.title"
              :value="region.id"
          />
        </el-select>
        <el-select
            v-model="selectedDistrictIds"
            placeholder="Tumanlarni tanlang"
            multiple
            filterable
            collapse-tags
            collapse-tags-tooltip
            :disabled="!selectedRegion"
            :loading="districtsLoading"
            style="width: 100%"
        >
          <el-option
              v-for="district in availableDistricts"
              :key="district.id"
              :label="district.title"
              :value="district.id"
          />
        </el-select>
      </div>

      <template #footer>
        <el-button @click="blockedDialogVisible = false">Bekor qilish</el-button>
        <el-button
            type="primary"
            :disabled="!selectedDistrictIds.length"
            :loading="addingBlocked"
            @click="onAddBlocked"
        >
          Bloklash
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;

  .back-btn img {
    margin-right: 6px;
  }

  .page-title {
    margin: 0;
    font-family: "Montserrat-Bold", sans-serif;
    color: #0a194e;
  }
}

.state-block {
  padding: 24px 0;
}

.form {
  max-width: 420px;
  padding-top: 8px;
}

// el-input-number `controls` o'chirilganda matnni markazga tekislaydi — chapga qaytaramiz.
.number-input {
  width: 100%;

  :deep(.el-input__inner) {
    text-align: left;
  }
}

.field-hint {
  margin: 4px 0 0;
  color: #999999;
  font-size: 12px;
  line-height: 1.4;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}

.blocked-add {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.blocked-dialog-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-btn {
  width: 34px;
  height: 34px;
  padding: 0;
}

.winner-flow {
  max-width: 620px;
  padding-top: 8px;
}

.winner-steps {
  margin-top: 20px;
  // Vertikal el-step balandligi kontentga qarab cho'ziladi.
  :deep(.el-step__main) {
    padding-bottom: 8px;
  }

  :deep(.el-step__title) {
    font-family: "Montserrat-SemiBold", sans-serif;
    font-size: 15px;
    line-height: 1.6;
  }
}

.winner-step {
  padding: 4px 0 16px;

  &__text {
    margin: 0;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.5;
  }

  &__message {
    margin: 8px 0 0;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.5;

    &.is-finish {
      background: #f0f9eb;
      color: #529b2e;
    }

    &.is-error {
      background: #fef0f0;
      color: #c45656;
    }
  }

  &__actions {
    margin-top: 12px;
  }
}

.winner-actions {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}
</style>
